import i18n from '@/plugins/i18n';

const rdsMySqlCharts = () => ({
  lineChartsSubscriptionPage: [
    {
      metricName: 'rds_database_connections',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.database'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.min'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.dbConnections'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'rds_cpu_utilization',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('aws.database'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.min'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.dbCpuUtilisation'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
    },
  ],
  lineChartsDatabasePage: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.freeStorageSpace'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#2F91EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_free_storage_space',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInGb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1073741824',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.cpuMemoryUtilisation'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F59600'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_cpu_utilization',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.percentage'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.freeableMemory'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#85CF6B'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_freeable_memory',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.sizeInGb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1073741824',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.networkIo'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F59600', '#2F91EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'rds_network_receive_throughput,rds_network_transmit_throughput',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.mb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.totalReadWrite'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#85CF6B', '#2F91EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_read_iops,rds_write_iops',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.totalBytesWrittenAndRead'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F59600', '#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_write_throughput,rds_read_throughput',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.ioOperationsWaitingForDiskAccess'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#85CF6B'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_disk_queue_depth',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.millisecondsPerReadIoOperation'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_read_latency',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.millisecondsPerWriteIoOperation'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#2F91EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_write_latency',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.swapUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#EA7699'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_swap_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.databaseConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#2F91EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_database_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.replicaLag'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#2F91EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_replica_lag',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.binLogDiskUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F59600'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'rds_bin_log_disk_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
    },
  ],
});

export default rdsMySqlCharts;
